var _path, _path2, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0D4C94",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 551.034 551.034",
    style: {
      enableBackground: "new 0 0 551.034 551.034"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.517,
    y1: 4.5714,
    x2: 275.517,
    y2: 549.7202,
    gradientTransform: "matrix(1 0 0 -1 0 554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E09B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#C74C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#C21975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7024C4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "M386.878,0H164.156C73.64,0,0,73.64,0,164.156v222.722 c0,90.516,73.64,164.156,164.156,164.156h222.722c90.516,0,164.156-73.64,164.156-164.156V164.156 C551.033,73.64,477.393,0,386.878,0z M495.6,386.878c0,60.045-48.677,108.722-108.722,108.722H164.156 c-60.045,0-108.722-48.677-108.722-108.722V164.156c0-60.046,48.677-108.722,108.722-108.722h222.722 c60.045,0,108.722,48.676,108.722,108.722L495.6,386.878L495.6,386.878z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.517,
    y1: 4.5714,
    x2: 275.517,
    y2: 549.7202,
    gradientTransform: "matrix(1 0 0 -1 0 554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E09B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#C74C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#C21975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7024C4"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_81_",
    d: "M275.517,133C196.933,133,133,196.933,133,275.516 s63.933,142.517,142.517,142.517S418.034,354.1,418.034,275.516S354.101,133,275.517,133z M275.517,362.6 c-48.095,0-87.083-38.988-87.083-87.083s38.989-87.083,87.083-87.083c48.095,0,87.083,38.988,87.083,87.083 C362.6,323.611,323.611,362.6,275.517,362.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.306,
    y1: 4.5714,
    x2: 418.306,
    y2: 549.7202,
    gradientTransform: "matrix(1 0 0 -1 0 554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E09B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#C74C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#C21975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7024C4"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_83_",
    cx: 418.306,
    cy: 134.072,
    r: 34.149
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.68b3796f3c4b3d11a652fad2784112b5.svg";
export { ForwardRef as ReactComponent };